var React = require('react');

function BellIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.68403 7.96669L6.07056 11.9238C6.06288 11.9733 6.06032 12.0235 6.05521 12.0734C5.97586 12.8465 4.6875 13.1471 4.6875 14.5226C4.6875 14.9071 4.98954 15.2188 5.36213 15.2188H14.6379C15.0105 15.2188 15.3125 14.9071 15.3125 14.5226C15.3125 13.1472 14.0829 12.8465 14.0071 12.0734C14.0022 12.0235 13.9996 11.9733 13.9919 11.9238L13.3785 7.96669C12.9443 3.59444 7.1182 3.59444 6.68403 7.96669Z","stroke":"white","strokeWidth":"1.25","key":0}),React.createElement("path",{"d":"M9.0625 17.1875C9.0625 17.1875 9.04907 17.1777 9.04907 17.2336C9.04907 17.5909 9.38854 17.9688 10.0068 17.9688C10.625 17.9688 10.9521 17.5909 10.9521 17.2336C10.9521 17.1777 10.9375 17.1875 10.9375 17.1875H9.0625Z","stroke":"white","strokeWidth":"1.25","key":1})]);
}

BellIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = BellIcon;

BellIcon.default = BellIcon;
